// The video editor's timeline strings (components/Editor), under t('editor.rve.timeline.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  // Header: undo / redo
  undoTitle: 'تراجع (Ctrl/Cmd + Z)',
  undoLabel: 'تراجع عن آخر خطوة',
  redoTitle: 'إعادة (Ctrl/Cmd + Shift + Z)',
  redoLabel: 'إعادة آخر خطوة',
  // Header: splitting
  selectItemToSplit: 'اختار عنصر عشان تقسّمه عند مؤشر التشغيل',
  selectOneItemToSplit: 'اختار عنصر واحد بس عشان تقسّمه',
  movePlayheadToSplit: 'حرّك مؤشر التشغيل على العنصر اللي اخترته عشان تقسّمه',
  splitSelectedItem: 'قسّم العنصر المختار عند مؤشر التشغيل',
  clickItemsToSplit: 'دوس على عناصر التايم لاين عشان تقسّمها',
  enableSplittingMode: 'شغّل وضع التقسيم',
  autoRemoveEmptyTracks: 'امسح المسارات الفاضية تلقائي',
  enableAutoRemoveEmptyTracks: 'شغّل المسح التلقائي للمسارات الفاضية',
  // Header: playback
  jumpToStart: 'روح للبداية',
  jumpToEnd: 'روح للنهاية',
  playVideo: 'شغّل الفيديو',
  pauseVideo: 'وقّف الفيديو',
  // Header: aspect ratio
  aspectRatio: 'مقاس الفيديو',
  widescreen: 'عريض',
  vertical: 'طولي',
  square: 'مربع',
  portrait: 'بورتريه',
  // Header: zoom and collapse
  zoomOut: 'زووم أوت',
  zoomIn: 'زووم إن',
  resetZoom: 'رجّع الزووم',
  timelineZoom: 'زووم التايم لاين',
  expandTimeline: 'كبّر التايم لاين',
  collapseTimeline: 'صغّر التايم لاين',
  // Track handles
  reorderTrack: 'غيّر ترتيب المسار',
  enableMagnetic: 'شغّل التايم لاين المغناطيسي',
  disableMagnetic: 'اقفل التايم لاين المغناطيسي',
  deleteTrack: 'امسح المسار',
  gapTitle: 'فراغ: {start}s - {end}s (دوس عشان تقفله)',
  // Item context menu
  duplicate: 'كرّر',
  duplicateItems: 'كرّر العناصر ({n})',
  splitAtPlayhead: 'قسّم عند مؤشر التشغيل',
  delete: 'امسح',
  deleteItems: 'امسح العناصر ({n})',
  // Item labels
  videoLabel: 'فيديو',
  imageLabel: 'صورة',
  textLabel: 'نص',
  audioLabel: 'صوت',
  captionLabel: 'كابشن',
  subtitlesLabel: 'كابشن',
  stickerLabel: 'ستيكر',
  blurLabel: 'بلور',
  blurLevelLabel: 'بلور ({n}px)',
  unknownLabel: 'غير معروف',
  typeLabel: 'النوع: {type}',
  loading: 'بيحمّل...',
  noWaveform: 'مفيش موجة صوت',
  // Shared editor UI (ui/dialog, ui/sidebar)
  close: 'اقفل',
  toggleSidebar: 'افتح أو اقفل الشريط الجانبي',
};
